import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { PrintOrderStatus } from "src/app/shared/models/enums/PrinterOrderStatus-enum";
import { PrintOrder } from "src/app/shared/models/PrintOrder";

@Component({
	selector: "app-kitchen-performance-dashboard",
	templateUrl: "./kitchen-performance-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class KitchenPerformanceDashboardComponent implements OnInit {
	chartConfig = {
		config: this.app.references.lineChartConfig("Kitchen Performance"),
		data: undefined,
	};

	averageTicketTimeAllStations: number;

	gaugeChart = {
		canvasWidth: 200,
		needleValue: 0,
		name: `Average Ticket Time`,
		bottomLabel: undefined,
		options: {
			hasNeedle: true,
			needleColor: "gray",
			needleUpdateSpeed: 1000,
			arcColors: ["rgb(44, 151, 222)", "lightgray"],
			arcDelimiters: [],
			rangeLabel: [],
			needleStartValue: 0,
		},
	};

	metricDate: string = "7-days";
	activeButton = "p-button-raised p-button-primary m-2 w-100";
	inactiveButton = "p-button-raised p-button-secondary m-2 w-100";

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.printOrderJobs.subscribe((data) => {
			if (data.length > 0) {
				this.kitchenGaugeChartBuild(data);
			}
		});
	}

	changeMetricDate(metricDateFormat) {
		this.metricDate = metricDateFormat;
		switch (metricDateFormat) {
			case "7-days":
				this.kitchenGaugeChartBuild(this.venueService.printOrderJobs.getValue());
				break;
			case "yesterday":
				this.kitchenGaugeChartBuild(
					this.venueService.printOrderJobs
						.getValue()
						.filter(
							(x) =>
								x.created > this.app.moment().subtract(1, "days").startOf("day").format() &&
								x.created < this.app.moment().subtract(1, "days").endOf("day").format()
						)
				);

				break;
			case "today":
				this.kitchenGaugeChartBuild(
					this.venueService.printOrderJobs
						.getValue()
						.filter((x) => x.created > this.app.moment().startOf("day").format() && x.created < this.app.moment().endOf("day").format())
				);
				break;
		}
	}

	kitchenGaugeChartBuild(printOrders: PrintOrder[]) {
		let lowestValue = 0;
		let highsestValue = 0;
		console.log(printOrders.length);
		if (printOrders.length === 0) {
			this.gaugeChart.needleValue = 0;
			this.gaugeChart.bottomLabel = `No orders found`;
			this.gaugeChart.options.rangeLabel = [lowestValue.toString(), highsestValue.toString()];
			this.gaugeChart.options.arcDelimiters = [33, 66];
			return;
		}

		const individualStationData: {
			deviceName: string;
			printerId: number;
			totalOrders: number;
			runningDuration: number;
			averageDuration: number;
			borderColor: string;
			dailyOrder: {
				day: string;
				count: number;
				duration: number;
				averageDuration?: number;
			}[];
		}[] = [];

		const dates: string[] = [];

		printOrders.forEach((printOrder) => {
			if (printOrder.status === PrintOrderStatus.BUMPED) {
				const stationRecord = individualStationData.find((station) => station.printerId === printOrder.printerId);
				lowestValue = printOrder.duration < lowestValue ? printOrder.duration : lowestValue;
				highsestValue = printOrder.duration > highsestValue ? printOrder.duration : highsestValue;

				if (stationRecord) {
					stationRecord.totalOrders++;
					stationRecord.runningDuration = stationRecord.runningDuration + printOrder.duration;
					stationRecord.averageDuration = stationRecord.runningDuration / stationRecord.totalOrders;
					const day = stationRecord.dailyOrder.find((i) => i.day === this.app.moment(printOrder.created).format("l"));
					if (!day) {
						stationRecord.dailyOrder.push({
							day: this.app.moment(printOrder.created).format("l"),
							count: 1,
							duration: printOrder.duration,
							averageDuration: printOrder.duration,
						});
					} else {
						day.count++;
						day.duration += printOrder.duration;
						day.averageDuration = day.duration / day.count;
					}
				} else {
					individualStationData.push({
						deviceName: printOrder.deviceName,
						printerId: printOrder.printerId,
						totalOrders: 1,
						runningDuration: printOrder.duration,
						averageDuration: printOrder.duration,
						borderColor: this.app.references.pastelColorList[individualStationData.length],
						dailyOrder: [
							{
								day: this.app.moment(printOrder.created).format("l"),
								count: 1,
								duration: printOrder.duration,
								averageDuration: printOrder.duration,
							},
						],
					});
				}
				if (!dates.some((i) => i === this.app.moment(printOrder.created).format("l"))) {
					dates.push(this.app.moment(printOrder.created).format("l"));
				}
			}
		});
		dates.sort((a, b) => (a > b ? 1 : -1));
		let averageTicketTime: number = 0;
		individualStationData.forEach((station) => {
			station.dailyOrder.sort((a, b) => (a.day > b.day ? 1 : -1));
			averageTicketTime += station.averageDuration;
		});

		this.averageTicketTimeAllStations = Math.round(averageTicketTime / individualStationData.length);

		this.chartConfig.data = {
			labels: dates,
			datasets: individualStationData.map((station) => {
				return {
					label: station.deviceName,
					data: station.dailyOrder.map((day) => day.averageDuration),
					borderColor: station.borderColor,
					backgroundColor: this.app.references.transparentize(station.borderColor, 0.5),
				};
			}),
		};

		this.gaugeChart.needleValue = (this.averageTicketTimeAllStations / highsestValue) * 100;
		this.gaugeChart.bottomLabel = `${this.averageTicketTimeAllStations} minutes`;
		this.gaugeChart.options.rangeLabel = [lowestValue.toString(), highsestValue.toString()];
		this.gaugeChart.options.arcDelimiters = [((highsestValue * 0.33) / highsestValue) * 100, ((highsestValue * 0.66) / highsestValue) * 100];
		console.log(this.gaugeChart);
	}
}
